module.exports = __webpack_public_path__ + "img/arrow-button-right-1.d7b00bca.svg";